module.exports = __webpack_public_path__ + "b0d6ef59a8.svg";